export default "__VITE_ASSET__Dvw9DSgc__"